//Se importan los types de cada acción para usar los que se requieran
import { types } from "../types/types";
import { store } from "../store/store";
import { returnDataRecord } from "./record/colombia/data-records-col";
import { returnDataRecord as returDataRecordCL } from "./record/chile/data-records-cl"
import { returnDataRecord as returDataRecordCR } from "./record/costarica/data-records-cr"
import { getIP } from "./ui";
import { issueFonasa } from "./record/chile/fonasa/fonasa";
import axios from "axios";

//Método para guardar el Log cuando se activa un BONO
const enviarLogDoctorBonoActivation = (
  action,
  profRut,
  profName,
  patientRut,
  patientName,
  patientLastName,
  responseFonasa,
  IP
) => {
  const reduxState = store.getState().company;
  const db = reduxState?.companyInstance?.db;

  //Se crea la fecha actual en la que se crea el Log
  let date = new Date();

  //Se registra en la colección el Log, almacenando la fecha de la acción, la acción y el UID de la persona que la originó
  db.collection("log")
    .add({
      log_date: date,
      action: action,
      professionalRut: profRut,
      professional: profName,
      patientRut: patientRut,
      patient: `${patientName} ${patientLastName}`,
      id_bono: responseFonasa.id_bono,
      folio: responseFonasa.folio,
      ip: IP.IPv4,
      country: IP.country_name,
    })
    .then((docRef) => { })
    .catch((error) => { });
};

//Método para guardar el Log cuando se activa un BONO
const enviarLogDoctorErrorBonoActivation = (
  action,
  error,
  profRut,
  profName,
  patientRut,
  patientName,
  patientLastName,
  id_atencion,
  IP
) => {
  const reduxState = store.getState().company;
  const db = reduxState?.companyInstance?.db;

  //Se crea la fecha actual en la que se crea el Log
  let date = new Date();

  //Se registra en la colección el Log, almacenando la fecha de la acción, la acción y el UID de la persona que la originó
  db.collection("log")
    .add({
      log_date: date,
      action: action,
      error: error,
      professionalRut: profRut,
      professional: profName,
      patientRut: patientRut,
      patient: `${patientName} ${patientLastName}`.trim(),
      id_atencion: id_atencion,
      ip: IP.IPv4,
      country: IP.country_name,
    })
    .then((docRef) => { })
    .catch((error) => { });
};

export const saveSignatureBase64 = async (signature, dataDocument, setDataDocument, dataPatient, setInformed) => {
  const reduxState = store.getState().company;
  const db = reduxState?.companyInstance?.db;

  const country = dataDocument.scheduleCountry.replaceAll(" ", "").toLowerCase();
  const idRecord = dataDocument.timestamp.toString();
  const clinicalRecord = db.collection("attention").doc(country).collection(dataDocument.patientDNI).doc(idRecord);
  const dataAttention = returnDataRecord(dataDocument.serviceCode);

  const dataToSet = {
    typeConsult: dataDocument.serviceName,
    typeConsultCodeAlternative: dataDocument.serviceCodeAlternative,
    typeConsultCode: dataDocument.serviceCode,
    typeConsultDuration: dataDocument.serviceDuration,
    patientInfo: dataPatient,
    attention: dataAttention,
    professionalName: dataDocument.professionalName,
    professionalDNI: dataDocument.professionalDNI,
    pathFiles: [],
    timeConsult: "",
    startTime: new Date(dataDocument.timestamp),
    idDocument: dataDocument.idDocument,
    informedConfirmation: false,
    timestamp: dataDocument.timestamp,
    control: dataDocument.control,
    timeZone: dataDocument.timeZone,
    specialtyName: dataDocument.scheduleSpecialtyName,
    specialtyCode: dataDocument.scheduleSpecialtyCode
  }

  clinicalRecord
    .get()
    .then((doc) => {
      if (doc.exists) {
        clinicalRecord.update({ patientSignature: signature, patientInfo: { ...dataPatient } }).then(() => {
          db.collection(`schedule_${country}`)
            .doc(dataDocument.idDocument)
            .update({
              informedConsent: true,
            })
            .then(() => {
              setInformed(true);
              setDataDocument({ ...dataDocument, informedConsent: true })
              window.open(dataDocument.urlDate);
            });
        })
      } else {
        clinicalRecord
          .set({
            ...dataToSet,
            patientSignature: signature
          }).then(() => {
            db.collection(`schedule_${country}`)
              .doc(dataDocument.idDocument)
              .update({
                informedConsent: true,
              })
              .then(() => {
                setInformed(true);
                setDataDocument({ ...dataDocument, informedConsent: true })
              });
          })
      }
    })
    .catch((error) => {
      console.log("Error getting document:", error);
    });

}

export const setInformedConsent = (data, dataDocument, dataPatient) => {
  const reduxState = store.getState().company;
  const db = reduxState?.companyInstance?.db;
  const urlServer = reduxState?.companyInstance?.urlServer;

  return async (dispatch) => {
    const countrySchedule = dataDocument.scheduleCountry.replaceAll(" ", "").toLowerCase();

    db.collection(`schedule_${countrySchedule}`)
      .doc(dataDocument.idDocument)
      .update({
        informedConsent: true,
      })
      .then(() => {
        /////////////////////////////// VALIDACIÓN SI SE DEBE ACTIVAR BONO O NO ///////////////////////////////
        if (dataDocument.scheduleCountry === "Chile") {
          if (
            dataDocument?.prevision === "FONASA" &&
            dataDocument?.id_atencion !== "" &&
            dataDocument?.hash !== "" && dataDocument.folio === ""
          ) {

            const dataPreBono = {
              id_atencion: dataDocument.id_atencion,
              hash: dataDocument.hash,
            };

            axios.post(`${urlServer}/fonasa/activacion`, dataPreBono)
              .then(async (response) => {

                /////////////////////////////// VALIDACIÓN SI PUDO ACTIVAR EL BONO ///////////////////////////////
                if (response.data.response.data.validarResponse !== undefined && response.data.response.data.validarResponse.estado === 1) {

                  getIP()
                    .then(responseIP => {
                      enviarLogDoctorBonoActivation('[Medipass Fonasa] Bonus Activation', dataDocument.professionalDNI, dataDocument.professionalName, dataDocument.patientDNI, dataDocument.patientName, dataDocument.patientLastName ?? "", response.data.response.data.bonos.info[0] !== undefined ? response.data.response.data.bonos.info[0] : response.data.mensaje, responseIP.data);
                    })

                  const dataFonasa = {
                    rutPatient: dataDocument.patientDNI,
                    folioInfo: response.data.response.data.bonos.info[0].folio,
                    codPrestacion: dataDocument.typeConsultCodeAlternative
                  };

                  const folioRef = db.collection("schedule_chile").doc(dataDocument.idDocument);

                  // Set the Folio
                  try {
                    await folioRef.update({
                      folio: response.data.response.data.bonos.info[0].folio
                    });
                    // console.log("Document successfully updated!");
                  } catch (error) {
                    // The document probably doesn't exist.
                    console.error("Error updating document: ", error);
                  }

                  const dataBono = {
                    "bonos": [
                      {
                        "id": dataDocument.id_bono
                      }
                    ]
                  }

                  axios.post(`${urlServer}/fonasa/imphtml`, dataBono)
                    .then(async (response) => {
                      sendEmailBono(dataDocument.patientEmail, dataDocument.patientName, response.data.medioPago.html)
                    });

                  // EMISION A FONASA
                  issueFonasa(dataDocument, dataFonasa);
                } else {
                  getIP()
                    .then(responseIP => {
                      enviarLogDoctorErrorBonoActivation('[Medipass Fonasa] Bonus Activation Failed', response.data.response.mensaje, dataDocument.professionalDNI, dataDocument.professionalName, dataDocument.patientDNI, dataDocument.patientName, dataDocument.patientLastName ?? "", dataDocument.id_atencion, responseIP.data);
                    })
                }
                /////////////////////////////// CATCH DEL ENDPOINT AL ACTIVAR EL PRE-BONO ///////////////////////////////
              }).catch((err) => {
                console.log(err)
                getIP()
                  .then(responseIP => {
                    enviarLogDoctorErrorBonoActivation('[Medipass Fonasa] Bonus Activation Failed', err.toString(), dataDocument.professionalRut, dataDocument.professionalName, dataDocument.patientRut, dataDocument.patientName, dataDocument.patientLastName, dataDocument.id_atencion, responseIP.data);
                  })
              })
            /////////////////////////////// ELSE VALIDACIÓN SI SE DEBÍA ACTIVAR BONO O NO ///////////////////////////////
          }
        }

        const docRefAttention = db.collection("attention").doc(countrySchedule).collection(dataDocument.patientDNI).doc(dataDocument.timestamp.toString());

        docRefAttention.get().then((doc) => {
          if (doc.exists) {
            docRefAttention.update({
              informedConsent: true,
            }).then(() => {

            }).catch((er) => {
              console.log(er)
            });
          } else {
            console.log("No such document!");

            let dataAttention = {};

            db.collection("service")
              .doc(dataDocument.serviceCode)
              .get()
              .then((docService) => {

                const dataService = {
                  medicines: docService.data().medicines,
                  order: docService.data().order,
                  procedure: docService.data().procedure,
                  license: docService.data().license,
                  imc: docService.data().imc,
                };

                if (dataDocument.scheduleCountry === "Chile") {
                  dataAttention = returDataRecordCL(dataService);
                }

                if (dataDocument.scheduleCountry === "Costa Rica") {
                  dataAttention = returDataRecordCR(dataService);
                }

                const dataToSet = {
                  typeConsult: dataDocument.serviceName,
                  typeConsultCodeAlternative:
                    dataDocument.serviceCodeAlternative,
                  typeConsultCode: dataDocument.serviceCode,
                  typeConsultDuration: dataDocument.serviceDuration,
                  patientInfo: dataPatient,
                  attention: dataAttention,
                  professionalName: dataDocument.professionalName,
                  professionalDNI: dataDocument.professionalDNI,
                  pathFiles: [],
                  timeConsult: "",
                  startTime: new Date(dataDocument.timestamp),
                  idDocument: dataDocument.idDocument,
                  informedConsent: true,
                  timestamp: dataDocument.timestamp,
                  control: dataDocument.control,
                  timeZone: dataDocument.timeZone,
                  specialtyName: dataDocument.scheduleSpecialtyName,
                  specialtyCode: dataDocument.scheduleSpecialtyCode,
                };

                docRefAttention.set({ ...dataToSet });

              });
          }
        }).catch((error) => {
          console.log("Error getting document:", error);
        });
      });
  };
};

export const sendEmailBono = async (patientEmail, patientName, bonoHTML) => {
  const reduxState = store.getState().company;
  const urlServer = reduxState?.companyInstance?.urlServer;

  try {
    const data = {
      patientEmail,
      patientName,
      bonoHTML,
    };

    const response = await axios.post(`${urlServer}/mails/sendTicketBono`, data);
    return response;
  } catch (error) {
    return error.toString();
  }
};

//Método para set las citas en el estado myDatesPatient
export const setMyDatesPatient = (dates) => ({
  type: types.myDatesPatient,
  payload: dates,
});

export const setLoadPatient = (country, data, dataPatients, actionDoc) => ({
  type: types.loadPatients,
  payload: { key: country, value: data, patients: dataPatients, actionDoc },
})

//Método que Set un historial en el estado Active
export const activeHistory = (patient) => ({
  type: types.historyActive,
  payload: { ...patient },
});

//Método para llamar el type para limpiar el estado Active
export const startCleanActive = () => {
  return async (dispatch) => {
    dispatch(cleanActive());
  };
};

//Método para limpiar el estado Active
export const cleanActive = () => ({
  type: types.historyActiveClean,
});

//Método para solicitar código de verificación o confirmación del código
export const getAction = (opcion, rutPatient) => {
  return async (dispatch) => {
    let typeOption = "";
    opcion === 1
      ? (typeOption = types.getCode)
      : (typeOption = types.confirmCode);
    //Realiza la acción que coincida con ese type
    dispatch({ type: typeOption });
    // LLama la función para guardar el Log de adición de tipo de usuario

    getIP()
      .then(response => {
        enviarLogPatient(typeOption, rutPatient, response.data);
      })
  };
};

//Método para enviar el error recibido durante el código de verificación en dado caso que falle
export const getActionInError = (error, rutPatient) => {
  return async (dispatch) => {
    //Realiza la acción que coincida con ese type
    dispatch({ type: types.errorCode });
    // LLama la función para guardar el Log de adición de tipo de usuario

    getIP()
      .then(response => {
        enviarLogErrorPatient(types.errorCode, error, rutPatient, response.data);
      })
  };
};

//Método para iniciar la limpieza del Estado
export const startCleanDatesPatient = () => {
  return async (dispatch) => {
    dispatch(cleanDatesPatient());
  };
};

//Método que llama el type para limpiar el Estado
export const cleanDatesPatient = () => ({
  type: types.cleanDatesPatient,
});

/////////////////////////////////////////////////////MÉTODOS PARA LOGS/////////////////////////////////////////////////////

//Método para guardar el Log del Doctor cuando agrega una nueva ficha médica
const enviarLogPatient = (action, rutPatient, IP) => {
  const reduxState = store.getState().company;
  const db = reduxState?.companyInstance?.db;

  //Se crea la fecha actual en la que se crea el Log
  let date = new Date();

  //Se registra en la colección el Log, almacenando la fecha de la acción, la acción y el UID de la persona que la originó
  db.collection("log")
    .add({
      log_date: date,
      action: action,
      patient: rutPatient,
      ip: IP.IPv4,
      country: IP.country_name
    });
};

//Método para guardar el Log de los errores del Doctor
const enviarLogErrorPatient = (action, error, email, IP) => {
  const reduxState = store.getState().company;
  const db = reduxState?.companyInstance?.db;

  //Se crea la fecha actual en la que se crea el Log
  let date = new Date();

  //Se registra en la colección el Log, almacenando la fecha de la acción, la acción, el error obtenido y el email que originó el error
  db.collection("log")
    .add({
      log_date: date,
      action: action,
      error: error,
      user: email,
      ip: IP.IPv4,
      country: IP.country_name
    });
};

/////////////////////////////////////////////////////MÉTODOS PARA LOGS////////////////////////////////////////////////////
